module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABIElEQVQ4T62TvUoDQRSFv7O7QZs0IpJGtLETBJtUgQVfQIIRRBBLG30AH8AHsLIWRDAgvoAQsEojBOxsFJsgYpNG2Z8rO2tCDCrRzXR37pxv7pm5V4ws2wpniVgmTRaB8me6h+c/UOJO562XYYn6gTUaPlE3RLYyCv0SmzqUKi01m0m27wBOHD/XIZl3h82rQloFr5KL0y54bZS289h/Ipi7zCA5YL225m42ykjbGEvfViHuMTtD9DB1dHVzLef5Ld7JBdr7UdwnZhDsxIXTwalsIwxJ4tW8bNv81f8gqQtnxw9uZfXaLmYzGAeghfEA9og4RnrNAPuYlTDvCGxqPIDeUXqIFE0EUNBC4Ucs+o2FG2kirTyA/HeYhv/+r+P8AQW8ruHIlkkNAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/stationTobu/errorStuts.png
// module id = 4758
// module chunks = 0